<template>
    <div class="ins-product-model" @click="hide_product_model">
        <div class="ins-product-model-main" @click.stop>
            <div class="ins-product-model-btn">
                <button
                    class="ins-btn-close iconfont icon-cm-cancel-1-copy"
                    @click="hide_product_model"
                ></button>
            </div>

            <div class="ins-main-right">
                <!-- <div class="ins-main-right_title">CHOOSE YOUR OPTIONS</div> -->
                <div class="ins-product-right_img_card">
                    <v-img-card
                        :data_url="
                            now_variant.feature_image
                                ? now_variant.feature_image.url
                                : product.feature_image
                                ? product.feature_image.url
                                : defaultImage
                        "
                    ></v-img-card>
                </div>

                <div class="ins-product-right_product_card">
                    <!--商品名称-->
                    <div class="ins-product-right_product_name">
                        <a
                            class="title_font"
                            :href="product.product_url"
                            :title="product.title || product.post_title"
                        >
                            {{ product.title || product.post_title }}
                        </a>
                    </div>

                <!--商品价格-->
                <p class="ins-product-right_product_price">
                    <v-selectprice
                        :price="now_variant.price"
                        :font-size="16"
                        :regular-font-size="16"
                        :regular_price_num="
                            now_variant.price - 0 <
                            now_variant.regular_price - 0
                                ? now_variant.regular_price
                                : 0
                        "
                        :disable_select="true"
                        :country="!show_currency_selector ? '' : $store.state.pricetype"
                    ></v-selectprice>
                </p>

                    <!-- 变种 -->

                    <div class="ins-product-right_variant_attrs_box">
                        <div
                            class="variant_select"
                            v-for="(item, index) in product.variant_attrs"
                            :class="
                                item.value &&
                                    item.value.length > 6 &&
                                    'dropdown'
                            "
                            :key="item.name"
                        >
                            <label class="secondary_title">{{
                                item.name
                            }}</label>
                            <div
                                v-if="item.value && item.value.length < 7"
                                class="labelStyle"
                            >
                                <div
                                    v-for="subitem in item.value"
                                    :key="subitem"
                                    class="labelItem"
                                    :class="
                                        variant_attrs[index].value == subitem
                                            ? 'active'
                                            : ''
                                    "
                                >
                                    <input
                                        v-model="variant_attrs[index].value"
                                        :id="item.name + index + subitem"
                                        :value="subitem"
                                        type="radio"
                                    />
                                    <label
                                        class="secondary_title"
                                        :class="
                                            variant_attrs[index].value ==
                                            subitem
                                                ? 'main_button'
                                                : ''
                                        "
                                        :for="item.name + index + subitem"
                                        >{{ subitem }}</label
                                    >
                                </div>
                            </div>
                            <div v-else>
                                <select
                                    class="secondary_title"
                                    v-model="variant_attrs[index].value"
                                    name
                                    id
                                >
                                    <option
                                        v-for="subitem in item.value"
                                        :key="subitem"
                                        :value="subitem"
                                        >{{ subitem }}</option
                                    >
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- 商品加购按钮 -->
                    <div
                        class="ins-product-right_addbtn"
                        :style="
                            now_variant.buy_able
                                ? ''
                                : 'cursor: no-drop !important'
                        "
                    >
                        <button
                            v-if="now_variant.buy_able"
                            type="button"
                            class="product_single_add_button"
                            :class="{
                                product_single_add_button_disabled: disabled,
                                'add-to-cart': theme == 'showtime',
                                'transition-main': theme == 'vogue',
                               // 'transition-minor': theme == 'vogue',
                               // minor_button: theme != 'vogue',
                                main_button: theme != 'vogue'
                            }"
                            @click="
                                !disabled &&
                                    is_add_cart(addproduct, now_variant)
                            "
                            :disabled="disabled"
                        >
                            <span
                                v-if="theme == 'showtime'"
                                class="iconfont icongouwuche"
                            ></span>
                            <span class="secondary_title">
                                {{ $t("detail.add_to_cart") }}
                            </span>
                        </button>
                        <button
                            v-else
                            type="button"
                            class="product_single_add_button product_single_add_button_disabled soldout"
                            :class="{
                                'add-to-cart':
                                    theme == 'showtime' || theme == 'vogue'
                            }"
                            :disabled="true"
                        >
                            <span class="secondary_title">{{
                                $t("detail.sold_out")
                            }}</span>
                        </button>
                    </div>
                    <!--continue Shopping-->
                    <div
                        class="ins-product-right_continuebtn"
                        :style="
                            now_variant.buy_able
                                ? ''
                                : 'cursor: no-drop !important'
                        "
                    >
                        <button
                            class="ins-product-right_continuebtn_main"
                            :class="[
                                theme == 'vogue'
                                    ? 'transition-minor text-uppercase'
                                    : 'minor_button',
                                { product_single_add_button_disabled: disabled }
                            ]"
                            @click="hide_product_model"
                        >
                            <span class="secondary_title">
                                {{$t('shopping.continue_shipping')}}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vImgCard from "../common/imgCard.vue";
// import vAddCardHeight from "./addCardHight.vue";
// import vAllOptionSelect from "./allOptionSelect.vue";
// import vItemOptionSelect from "./itemOptionSelect.vue";

export default {
    props: {
        product: undefined,
        add_cart: {
            type: Function
        },
        hide_product_model: {
            type: Function
        },
        select_style: undefined,
        theme: {},
        disabled: undefined,
        show_currency_selector:undefined
    },

    data() {
        return {
            now_variant: {},
            addproduct: {
                quantity: "1",
                product_id: this.product.ID
            },
            variant_attrs: []
        };
    },

    methods: {
        getVariants() {
            let { variants } = this.product;
            //初始化状态，若有变种第一次变种为第一个
            if (variants && variants.length) {
                this.now_variant = variants[0];
                this.addproduct.variant_id = variants[0].ID;
                this.attrs = JSON.parse(JSON.stringify(variants[0].attrs));
            } else {
                //若无变种 则深拷贝商品
                let product = JSON.stringify(this.product);
                this.now_variant = JSON.parse(product);
            }
        },
        is_add_cart(addproduct, now_variant) {
            this.add_cart(addproduct, now_variant);
            this.hide_product_model();
        }
    },
    beforeMount() {
        this.getVariants();
           this.addproduct.product_id = this.product.ID;
        if (this.product.variant_attrs && this.product.variant_attrs.length) {
            this.product.variant_attrs.forEach(item => {
                this.variant_attrs.push({
                    name: item.name,
                    value: item.value[0]
                });
            });
        }
    },
    watch: {
        variant_attrs: {
            handler(newName) {
                this.product.variants.some(item => {
                    let res = item.attrs.every(subitem => {
                        return newName.some(lowitem => {
                            return (
                                lowitem.name == subitem.name &&
                                lowitem.value == subitem.value
                            );
                        });
                    });
                    if (res) {
                        // 如果变种商品有图片则切换轮播图
                        this.now_variant = item;
                        this.addproduct.variant_id = item.ID;
                        this.$store.dispatch("change_now_variant", item);
                        return res;
                    }
                });
            },
            immediate: false,
            deep: true
        },
        product: {
            handler(newV) {
                this.getVariants();
                this.addproduct.product_id = this.product.ID;
                if (
                    this.product.variant_attrs &&
                    this.product.variant_attrs.length
                ) {
                    this.product.variant_attrs.forEach(item => {
                        this.variant_attrs.push({
                            name: item.name,
                            value: item.value[0]
                        });
                    });
                }
            }
        }
    },
    components: {
        vImgCard,
        // vAddCardHeight,
        // vItemOptionSelect,
        // vAllOptionSelect
    }
};
</script>
<style scoped lang="scss">
.ins-product-model {
    position: fixed;
    display: flex;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    z-index: 999;
    padding: 40px 60px;
    justify-content: center;
    align-items: center;

    overflow-y: auto;
    .ins-product-model-main {
        // width: 100%;
        // max-width: 960px;
        // min-height: 650px;
        // margin: 40px auto;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .ins-main-right {
            background: #ffffff;
            box-shadow: 0px 2px 4px 0px #dddddd;
            // position: absolute;
            // top: 0;
            // right: 0;
            width: 480px;
            // height: 100%;

            display: flex;
            flex-direction: column;
            align-items: center;
            &_title {
                padding: 10px 0;
                font-size: 15px;
                color: #333333;
            }
            .ins-product-right {
                &_img_card {
                    width: 100%;
                    line-height: 0;
                    ::v-deep {
                        .imgCard {
                            height: 270px;
                            padding: unset;
                            background: #eaeaea;
                            img {
                                position: absolute;
                                max-width: 100% !important;
                                max-height: 100% !important;
                                width: 100% !important;
                                height: 100% !important;
                                object-fit: contain;
                                -o-object-fit: contain;
                                display: block;
                                top: 0;
                                left: 50%;
                                transform: translateX(-50%);
                            }
                        }
                    }
                }
                &_product_card {
                    margin: 20px auto;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 0 20px;
                }
                &_product_name {
                    font-size: 18px;
                    color: #424242;
                    height: 32px;
                    line-height: 16px;
                    >a{
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical
                    }

                }
                &_product_price {
                    margin-bottom: 10px;
                }
                &_variant_attrs_box {
                    width: 100%;
                    .variant_select {
                        position: relative;
                        padding: 10px 0;
                        .secondary_title,
                        .labelStyle {
                            display: flex;
                            justify-content: center;
                        }
                        & > label {
                            color: #1e0909;
                            font-family: "Roboto", sans-serif;
                            pointer-events: none;
                            font-weight: bold;
                            font-size: 15px;
                            line-height: 1.2;
                            // text-transform: capitalize;
                        }
                        select {
                            position: relative;
                            list-style: none;
                            direction: ltr;
                            box-sizing: inherit;
                            font-size: 100%;
                            margin: 0;
                            text-transform: none;
                            display: block;
                            border-radius: 0;
                            height: 44px;
                            line-height: 22px;
                            padding: 12px;
                            color: #1e0909;
                            border: 1px solid #e4e4e4;
                            width: 100%;
                            // margin-bottom: 12px;
                            cursor: pointer;
                            font-weight: 400;
                            background: rgba(255, 255, 255, 0.8);
                            padding-left: 5px !important;
                            font-family: "Roboto", sans-serif;
                            border-color: rgba(17, 17, 17, 0.2);
                            appearance: none;
                            padding-right: 30px;
                            transition: 0s;
                        }
                        .labelStyle {
                            .labelItem {
                                display: inline-block;
                                label {
                                    margin: 0;
                                    cursor: pointer;
                                    font-weight: 600;
                                    font-style: normal;
                                    letter-spacing: 0.1em;
                                    line-height: 1;
                                    padding: 9px 11px;
                                    margin: 0 5px;
                                    font-size: 0.86667em;
                                    font-style: normal;
                                    background-color: #fff;
                                    border: 1px solid #d2d2d2;
                                    color: #222323;
                                    cursor: pointer;
                                }
                                input {
                                    clip: rect(0, 0, 0, 0);
                                    overflow: hidden;
                                    position: absolute;
                                    height: 1px;
                                    width: 1px;
                                    // &:focus + label,
                                    // &:active + label {
                                    //   background-color: #f2f2f2;
                                    // }
                                }
                            }
                            .active {
                                label {
                                    background-color: #1a1a1a;
                                    border-color: #1a1a1a;
                                    color: #fbfbfb;
                                }
                            }
                        }
                    }
                    .dropdown {
                        &::after {
                            content: "\e62a";
                            font-family: "iconfont";
                            position: absolute;
                            bottom: 15px;
                            right: 12px;
                            font-size: 15px;
                            color: rgba(17, 17, 17, 0.4);
                            pointer-events: none;
                        }
                    }
                }

                &_addbtn {
                    // height: 40px;
                    margin-top: 20px;
                    width: 100%;
                    ::v-deep {
                        .product_single_add_button {
                            height: 44px;
                            line-height: 22px;
                            margin: unset;
                        }
                    }
                    // &_main {
                    //     height: 44px;
                    //     padding: 10px 0;
                    //     width: 100%;
                    //     background: #333333;
                    //     border-radius: 2px;
                    //     color: #ffffff;
                    //     font-size: 14px;
                    // }
                }
                &_continuebtn {
                    // height: 40px;
                    margin-top: 12px;
                    width: 100%;
                    &_main {
                        height: 44px;
                        padding: 10px 0;
                        width: 100%;
                        background: #ffffff;
                        border-radius: 2px;
                        border: 1px solid #333333;
                        color: #333333;
                        font-size: 14px;
                    }
                }
            }

            .ins-right-top {
                padding-top: 15px;
                overflow-x: hidden;
                overflow-y: auto;
                flex: 1;
                & > * {
                    margin: 0 20px;
                }
                h5 {
                    font-size: 16px;
                    font-weight: 500;
                    color: #222222;
                    line-height: 22px;
                    letter-spacing: 1px;
                }
                .ins-product-box {
                    margin: 0 10px;
                    .ins-product {
                        text-align: center;
                        width: 50%;
                        display: inline-block;
                        padding: 6px 10px;
                        vertical-align: top;
                        &::v-deep {
                            .item_gallery {
                                max-width: 80px;
                                max-height: 80px;
                                margin: 0 auto;
                            }

                            .item_price {
                                .selectpricewrap {
                                    line-height: 16px;
                                    .product_price_price,
                                    .product_price_cross {
                                        line-height: 16px;
                                    }
                                }
                            }
                            .item_button {
                                margin-top: 4px;
                                padding: 7.5px 0;
                            }
                        }
                    }
                }
                .ins-text-box {
                    padding-top: 20px;
                }
            }
            .ins-right-bottom {
                padding: 20px 20px 0;
                .ins-home {
                    background: #eeeeee;
                    padding: 8px 5px 7px;
                    text-align: center;
                    border-radius: 4px;
                    a {
                        font-size: 12px;
                        font-weight: 500;
                        color: #999999;
                        line-height: 17px;
                        display: block;
                        text-decoration: none;
                    }
                }
            }
        }
        .ins-mb-top {
            padding: 14px 0;
            position: relative;
            & > p {
                text-align: center;
                font-size: 16px;
                font-weight: 500;
                color: #222222;
                line-height: 22.5px;
                letter-spacing: 2px;
            }
            button {
                position: absolute;
                left: 4px;
                top: 3px;
                padding: 10px;
                cursor: pointer;
                svg {
                    height: 14px;
                }
            }
        }
    }
    .ins-product-model-btn {
        display: block;
        margin: 0;
        padding: 0;
        text-align: center;
        button {
            width: 40px;
            height: 40px;
            line-height: 40px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            color: #ffffff;
            svg {
                width: 25px;
                path {
                    fill: white;
                }
            }
        }
        .ins-btn-prev {
            left: -60px;
        }
        .ins-btn-next {
            right: -60px;
        }
        .ins-btn-close {
            position: fixed;
            top: 0;
            right: 0;
            transform: unset;
        }
    }
}
@media screen and(max-width: 768px) {
    .ins-product-model {
        padding: 0;
        .ins-product-model-main {
            overflow-y: auto;
            min-height: 100%;
            .ins-main-right {
                position: relative;
                width: 100%;
                padding: 0 0 32px;
                .ins-right-top {
                    overflow-x: unset;
                    overflow-y: unset;
                    & > * {
                        margin: 0 18px;
                    }
                    h5 {
                        margin-bottom: 8px;
                    }
                    .ins-product-box {
                        margin: 0 6.5px;
                        .ins-product {
                            padding: 8px 11.5px;
                        }
                    }
                    .ins-text-box {
                        padding-top: 24px;
                    }
                }
                .ins-right-bottom {
                    padding-top: 24px;
                }
            }
        }
        .ins-product-model-btn {
            display: none;
        }
    }
}
</style>
